import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import CheckboxField from 'components/application/CheckboxField';
import Tooltip from 'components/application/Tooltip';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import DownloadIcon from '-!svg-react-loader?name=DownloadIcon!icons/download.svg';
import TrashIcon from '-!svg-react-loader?name=TrashIcon!icons/ic-trash.svg';

export default function AdditionalProjectDocumentsRow({
  onDeleteIconClick,
  onUpdateCoverSheetSelection,
  pdf,
  shouldBlockMutations,
}) {
  const currentActor = useCurrentActor();

  return (
    <tr className='hover:tw-bg-grey-025' key={pdf.id}>
      <td
        className='tw-border-grey-100 tw-pl-5 tw-text-m tw-font-medium tw-text-grey-900'
        id={pdf.id}
      >
        <div className='tw-flex tw-h-8 tw-items-center tw-truncate'>
          <span className='tw-truncate'>{pdf.attributes.filename}</span>
        </div>
      </td>
      <td className='tw-border-grey-100 tw-text-center'>
        <div className='tooltip-parent tw-mr-2 tw-inline-flex tw-h-8 tw-w-8 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-0 tw-text-grey-500 hover:tw-bg-blue-025 hover:tw-text-grey-600 active:tw-bg-blue-050 active:tw-text-grey-600'>
          <a
            className='tw-inline-flex tw-h-full tw-w-full tw-items-center tw-justify-center'
            href={`/pdfs/${pdf.id}`}
          >
            <DownloadIcon height={24} width={24} />
            <Tooltip
              className='tooltip-dark--max-w-xxs'
              placement='top'
              tooltip='Download'
              trigger='hover'
            />
          </a>
        </div>
        <div
          className='tooltip-parent tw-ml-2 tw-inline-flex tw-h-8 tw-w-8 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-0 tw-text-grey-500 hover:tw-bg-red-025 hover:tw-text-red-600 active:tw-bg-red-050 active:tw-text-red-600'
          data-element-name='delete-pdf'
          onClick={() => !shouldBlockMutations && onDeleteIconClick(pdf.id)}
        >
          <TrashIcon
            className={classNames(
              shouldBlockMutations && '[&_path]:tw-fill-grey-100',
            )}
            height={24}
            width={24}
          />
          <Tooltip
            className='tooltip-dark--max-w-xxs'
            placement='top'
            tooltip='Delete'
            trigger='hover'
          />
        </div>
      </td>
      <td className='tw-border-grey-100'>
        <div className='tw-flex tw-h-8 tw-items-center tw-justify-center'>
          <Tooltip
            className='tooltip-dark'
            placement='top'
            tooltip={`Added to the beginning of the ${currentActor?.division?.attributes?.singularRAMSName || 'RAMS'}`}
            trigger='hover'
          >
            <label className='tw-m-0 tw-cursor-pointer'>
              <CheckboxField
                checked={!!pdf.attributes.coverSheet}
                disabled={shouldBlockMutations}
                name={`pdf_${pdf.id}_${pdf.attributes.filename}`}
                onChange={(e) =>
                  onUpdateCoverSheetSelection({
                    pdfId: pdf.id,
                    selected: e.target.checked,
                  })
                }
              />
            </label>
          </Tooltip>
        </div>
      </td>
    </tr>
  );
}

AdditionalProjectDocumentsRow.propTypes = {
  onDeleteIconClick: PropTypes.func.isRequired,
  onUpdateCoverSheetSelection: PropTypes.func.isRequired,
  pdf: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    attributes: PropTypes.shape({
      filename: PropTypes.string.isRequired,
      coverSheet: PropTypes.bool,
    }).isRequired,
  }),
  shouldBlockMutations: PropTypes.bool.isRequired,
};
